import { useEffect } from 'react'

import { format } from 'date-fns'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { PlantasBloco } from '@/features/plantas/entities/planta-bloco'
import { useSuspensePlantasBloco } from '@/features/plantas/hooks/use-suspense-plantas-torre'
import type { TPropostaSchemaInput } from '@/features/proposta/schemas'
import { CardEtapaInicial } from '@/pages/proposta/etapa-informacoes-iniciais/card-etapa-inicial'
import { Render } from '@/shared/components/render-if'
import { ComboboxField } from '@/shared/components/ui/combobox'

export const CardPlanta = () => {
  const { t } = useTranslation('proposta')
  const { control, setValue, watch } = useFormContext<TPropostaSchemaInput>()
  const idExternoBlocoUnidade = watch('informacoesIniciais.simulacaoUnidade.bloco.idExterno')
  const plantaSelecionada = watch('informacoesIniciais.planta')
  const dataMarcacaoAlvenaria = watch('informacoesIniciais.simulacaoUnidade.produto.dataMarcacaoAlvenaria')

  const { data: plantas } = useSuspensePlantasBloco(idExternoBlocoUnidade)

  const variant = plantaSelecionada.id ? 'completed' : 'default'
  const isDataAlvenariaAnteriorHoje = new PlantasBloco(plantas).isDataAlvenariaAnteriorHoje(dataMarcacaoAlvenaria)

  useEffect(() => {
    const plantasBloco = new PlantasBloco(plantas)
    if (isDataAlvenariaAnteriorHoje && !plantaSelecionada.id) {
      const primeiraPlanta = plantasBloco.getPrimeiraPlantaDoBloco()
      setValue('informacoesIniciais.planta', primeiraPlanta)
    }
  }, [dataMarcacaoAlvenaria, isDataAlvenariaAnteriorHoje, plantas, setValue])

  return (
    <CardEtapaInicial variant={variant}>
      <CardEtapaInicial.Content
        label={t('informacoes_iniciais.cards.planta.titulo')}
        description={
          isDataAlvenariaAnteriorHoje
            ? t('informacoes_iniciais.cards.planta.tipo')
            : t('informacoes_iniciais.cards.planta.selecione')
        }
      >
        <Render.If condition={dataMarcacaoAlvenaria}>
          {(data) => (
            <p className="text-xs">
              <span className="font-semibold">{t('informacoes_iniciais.cards.planta.marcacao_alvenaria')}</span>
              {` ${format(data, 'dd/MM/yyyy')}`}
            </p>
          )}
        </Render.If>
      </CardEtapaInicial.Content>
      <CardEtapaInicial.Action>
        <ComboboxField
          data-testid="selecao-planta"
          name="informacoesIniciais.planta"
          valueMode="object"
          objectProperties={['id', 'descricao']}
          control={control}
          placeholder={t('informacoes_iniciais.cards.selecione')}
          options={plantas}
          labelProperty="descricao"
          valueProperty="id"
          initialValue={{ id: '', descricao: '' }}
          disableFilter={isDataAlvenariaAnteriorHoje}
        />
      </CardEtapaInicial.Action>
    </CardEtapaInicial>
  )
}
